import { render, staticRenderFns } from "./MenuItemBoxFees.vue?vue&type=template&id=ae28b404&"
import script from "./MenuItemBoxFees.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports